import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

// Single source of truth for how many columns the grid layout renders. It stays private to the
// layout: consumers that need to align with the grid (e.g. a full-width carousel injected as an
// adSpace) receive the resulting count through `getGridItem`, they do not read the breakpoints.
// The `grid-template-columns` declarations in ./index.scss mirror this map — keep both in sync.
const COLUMNS_BY_BREAKPOINT = [
  {columns: 4, matches: ({isXxlUp}) => isXxlUp},
  {columns: 3, matches: ({isXlUp}) => isXlUp},
  {columns: 2, matches: ({isSmUp}) => isSmUp},
  {columns: 1, matches: () => true}
]

// `useMediaQuery` returns `defaultMatches` on the first client render and only reads `matchMedia` in
// an effect, so an unseeded hook reports one column on every device until hydration finishes. Callers
// pass `defaultDesktop` from the user agent, which the server already resolved, to keep both renders
// on the same count. It is a device hint, not a width: a narrow desktop window still settles on fewer
// columns after the effects run.
const useGridColumns = ({defaultDesktop = false} = {}) => {
  const isSmUp = useMediaQuery(useMediaQueryBreakpoints.sm, {defaultMatches: defaultDesktop})
  const isXlUp = useMediaQuery(useMediaQueryBreakpoints.xl, {defaultMatches: defaultDesktop})
  const isXxlUp = useMediaQuery(useMediaQueryBreakpoints.xxl, {defaultMatches: defaultDesktop})

  return COLUMNS_BY_BREAKPOINT.find(({matches}) => matches({isSmUp, isXlUp, isXxlUp})).columns
}

export default useGridColumns
